import { __assign, __rest } from "tslib";
import React from 'react';
import isEqual from 'lodash/isEqual';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { useDropdownItems } from '../../hooks/useDropdownItems';
import StandardDropdownMenu from '../StandardDropdown/StandardDropdownMenu';
import { PopperDropdownManager, } from '../../PopperDropdownLayout';
import PopperIconToggleButton from '../../toggles/PopperIconToggleButton';
/**
 * Our DS `IconButton` with a context menu provided by our dropdown library.
 *
 * You can customize the popper or standarded menu instance via `popperManagerProps` or `standardMenuProps` respectively.
 */ var IconButtonWithContextMenu = React.memo(function (_a) {
    var items = _a.items, popperManagerProps = _a.popperManagerProps, standardMenuProps = _a.standardMenuProps, rest = __rest(_a, ["items", "popperManagerProps", "standardMenuProps"]);
    var filteredItems = useDropdownItems(items).filteredItems;
    var toggleId = useUniqueId();
    var dropdownId = useUniqueId();
    return (React.createElement(PopperDropdownManager, __assign({}, popperManagerProps),
        React.createElement(PopperIconToggleButton, __assign({ id: toggleId, "aria-haspopup": "menu", "aria-controls": dropdownId }, rest)),
        React.createElement(StandardDropdownMenu, __assign({ id: dropdownId, role: "menu", "aria-labelledby": toggleId, menuScrollable: true, items: filteredItems }, standardMenuProps))));
}, 
// Deep equal from lodash so we can compare the standard menu and popper manager prop collections
isEqual);
IconButtonWithContextMenu.displayName = 'IconButtonWithContextMenu';
export default IconButtonWithContextMenu;
//# sourceMappingURL=IconButtonWithContextMenu.js.map